import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PriorityService {

    constructor(private api: ApiService) { }

    getPriorities(pkPortal: number, criteria: Object = {}): Observable<any> {
        return this.api.get('vna/' + pkPortal + '/priority', criteria);
    }

    postPriority(body: Object): Observable<any> {
        return this.api.post('vna/priority', body);
    }

    putPriority(pk: number, body: Object): Observable<any> {
        return this.api.put('vna/priority', pk, body);
    }

    deletePriority(pk: number): Observable<any> {
        return this.api.remove('vna/priority', pk);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/priorities/services/priority.service.ts